import { ConfigResolver } from '@piccolohealth/config';
import type { AsyncReturnType } from '@piccolohealth/util';

export type Config = AsyncReturnType<typeof getConfig>;

export const getConfig = () => {
  //@ts-expect-error
  const windowEnv = window.env ?? {};
  const viteEnv = import.meta.env ?? {};
  const env = { ...viteEnv, ...windowEnv };

  return ConfigResolver.build(env, (env) => {
    return {
      env: env.get('VITE_PICCOLO_ENV').required().asString(),
      errorStackEnabled: env.get('VITE_PICCOLO_ERROR_STACK_ENABLED').asBool(),
      organizationMenuSuffix: env.get('VITE_PICCOLO_ORGANIZATION_MENU_SUFFIX').asString(),
      buildInfo: {
        commit: env.get('VITE_PICCOLO_GIT_COMMIT_HASH').asString(),
        branch: env.get('VITE_PICCOLO_GIT_BRANCH_NAME').asString(),
      },
      firebase: {
        apiKey: env.get('VITE_PICCOLO_FIREBASE_API_KEY').required().asString(),
        recaptchaDisabled: env.get('VITE_PICCOLO_FIREBASE_RECAPTCHA_DISABLED').required().asBool(),
      },
      api: {
        webUrl: env.get('VITE_PICCOLO_WEB_URL').required().asString(),
      },
      sentry: {
        environment: env.get('VITE_PICCOLO_ENV').required().asString(),
        dsn: env.get('VITE_PICCOLO_SENTRY_FRONTEND_DSN').required().asString(),
        enabled: env.get('VITE_PICCOLO_SENTRY_FRONTEND_ENABLED').required().asBool(),
        release: env.get('VITE_PICCOLO_GIT_COMMIT_HASH').asString(),
        normalizeDepth: 10,
      },
      intercom: {
        enabled: env.get('VITE_PICCOLO_INTERCOM_ENABLED').required().asBool(),
        appId: env.get('VITE_PICCOLO_INTERCOM_APP_ID').required().asString(),
      },
      knock: {
        apiKey: env.get('VITE_PICCOLO_KNOCK_API_KEY').required().asString(),
        feedId: env.get('VITE_PICCOLO_KNOCK_FEED_ID').required().asString(),
      },
      settings: {
        idleTimeout: env.get('VITE_PICCOLO_IDLE_TIMEOUT').required().asIntPositive(),
        idleWarningTimeout: env.get('VITE_PICCOLO_IDLE_WARNING_TIMEOUT').required().asIntPositive(),
        reconnectGraceTimeout: env
          .get('VITE_PICCOLO_EDITOR_RECONNECT_GRACE_TIMEOUT')
          .required()
          .asIntPositive(),
      },
    };
  });
};
